module.exports = "images/enfants_7.7a3c3689.png";